import {
  FileImage,
  Eye,
} from "lucide-react";

import "./ProviderCards.css";
import getImageUrl from "../../../utils/imageUrl";

function DocumentsCard({ provider }) {

  const documents = [
    {
      title: "Business Logo",
      image: provider.photos?.businessLogo,
    },
    {
      title: "Business Photo",
      image: provider.photos?.businessPhoto,
    },
    {
      title: "Aadhaar Front",
      image: provider.photos?.aadhaarFront,
    },
    {
      title: "Aadhaar Back",
      image: provider.photos?.aadhaarBack,
    },
    {
      title: "PAN Card",
      image: provider.photos?.panCard,
    },
  ];

  return (
    <div className="provider-card">

      <h3 className="card-title">
        Uploaded Documents
      </h3>

      <div className="documents-grid">

        {documents.map((doc, index) => {

          const imageUrl = doc.image
            ? getImageUrl(`/uploads/${doc.image}`)
            : null;

          return (
            <div
              className="document-card"
              key={index}
            >

              {imageUrl ? (

                <div className="document-image-wrapper">

                  <img
                    src={imageUrl}
                    alt={doc.title}
                    className="document-image"
                    onError={(event) => {
                      event.currentTarget.style.display =
                        "none";
                    }}
                  />

                </div>

              ) : (

                <div className="document-placeholder">

                  <FileImage size={42} />

                  <p>No Document</p>

                </div>

              )}

              <div className="document-footer">

                <h4>
                  {doc.title}
                </h4>

                {imageUrl && (

                  <a
                    href={imageUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="view-document-btn"
                  >
                    <Eye size={16} />
                    Open Document
                  </a>

                )}

              </div>

            </div>
          );

        })}

      </div>

    </div>
  );
}

export default DocumentsCard;